/** @file Field check for a boolean. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check for `true` or `false`. */
export const checkBoolean: FieldCheck = (value, path) => {
  if (typeof value !== 'boolean') failField(path, 'boolean', value);
};
